import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
import {
	type SidebarStoreState as State,
	SidebarStatuses,
} from '@atlassian/jira-shared-types/src/issue-sidebar.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook, type Action } from '@atlassian/react-sweet-state';

const { CLOSED, SHOWING_ISSUE } = SidebarStatuses;

const initialState: State = {
	state: {
		status: CLOSED,
	},
};

export const actions = {
	close:
		(): Action<State> =>
		({ setState }) =>
			setState({ state: { status: CLOSED } }),
	showIssue:
		(issueKey: IssueKey): Action<State> =>
		({ setState }) =>
			setState({ state: { status: SHOWING_ISSUE, issueKey } }),
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	name: 'versionDetailsSidebarStore',
	initialState,
	actions,
});

const useStore = createHook(Store);

export const useSidebarStore = () => {
	const [{ state }, sidebarActions] = useStore();
	return [state, sidebarActions] as const;
};

const useSidebarWithoutState = createHook(Store, {
	selector: null,
});

export const useSidebarActions = () => {
	const [, sidebarActions] = useSidebarWithoutState();
	return sidebarActions;
};
